import baseScroll from "./_internal/_baseScroll.js";

export default (el) => baseScroll(el, undefined, "pageXOffset", "scrollLeft");
